
// fetchData.js
import { collection, getDocs, query, limit, startAfter, orderBy } from "firebase/firestore";
import db from "../firebase/firebase"; // Import Firebase config file


export const fetchCollectionsData = async (lastDoc = null) => {
  try {
    // Fetch data from `homeImprovement`
    const homeImprovementRef = collection(db, "homeImprovement");
    let homeImprovementQuery = query(homeImprovementRef, orderBy("order"), limit(50));
    if (lastDoc) {
      homeImprovementQuery = query(homeImprovementRef, orderBy("order"), startAfter(lastDoc), limit(50));
    }
    const homeImprovementSnapshot = await getDocs(homeImprovementQuery);
    const homeImprovementData = homeImprovementSnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    // Fetch data from `electronicCollection`
    const electronicCollectionRef = collection(db, "electronicCollection");
    let electronicCollectionQuery = query(electronicCollectionRef, orderBy("order"), limit(50));
    if (lastDoc) {
      electronicCollectionQuery = query(electronicCollectionRef, orderBy("order"), startAfter(lastDoc), limit(50));
    }
    const electronicCollectionSnapshot = await getDocs(electronicCollectionQuery);
    const electronicCollectionData = electronicCollectionSnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    // Fetch data from `topCollection`
    const topCollectionRef = collection(db, "topCollection");
    let topCollectionQuery = query(topCollectionRef, orderBy("order"), limit(50));
    if (lastDoc) {
      topCollectionQuery = query(topCollectionRef, orderBy("order"), startAfter(lastDoc), limit(50));
    }
    const topCollectionSnapshot = await getDocs(topCollectionQuery);
    const topCollectionData = topCollectionSnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    // Fetch data from `ourCollection`
    const ourCollectionRef = collection(db, "ourCollection");
    let ourCollectionQuery = query(ourCollectionRef, orderBy("order"), limit(50));
    if (lastDoc) {
      ourCollectionQuery = query(ourCollectionRef, orderBy("order"), startAfter(lastDoc), limit(50));
    }
    const ourCollectionSnapshot = await getDocs(ourCollectionQuery);
    const ourCollectionData = ourCollectionSnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

 
  
    return {
      homeImprovementData,
      electronicCollectionData,
      topCollectionData,
      ourCollectionData,
      lastHomeImprovementDoc: homeImprovementSnapshot.docs[homeImprovementSnapshot.docs.length - 1],
      lastElectronicCollectionDoc: electronicCollectionSnapshot.docs[electronicCollectionSnapshot.docs.length - 1],
      lastTopCollectionDoc: topCollectionSnapshot.docs[topCollectionSnapshot.docs.length - 1],
      lastOurCollectionDoc: ourCollectionSnapshot.docs[ourCollectionSnapshot.docs.length - 1],

    };
  } catch (error) {
    console.error("Error fetching data:", error.message);
    return {
      homeImprovementData: [],
      electronicCollectionData: [],
      topCollectionData: [],
      ourCollectionData: [],
      lastHomeImprovementDoc: null,
      lastElectronicCollectionDoc: null,
      lastTopCollectionDoc: null,
      lastOurCollectionDoc: null,

    };
  }
};



